import { Injectable } from "@angular/core";
import { delay, Observable, of } from "rxjs";

import { HttpClient } from "@angular/common/http";
import * as saIdParser from "south-african-id-parser";
import { environment } from "../../../environments/environment";
import { IntentTypes } from "../../shared/enums";
import { LookupApiResponse } from "../../shared/models/api.response";
import { LookupDTO, SALookupDTO } from "../../shared/models/dto.models";

@Injectable({
  providedIn: "root",
})
export class LookupService {
  constructor(private http: HttpClient) {}

  errorResponse: LookupApiResponse = {
    error: "Invalid details",
    intent: IntentTypes.empty,
    lookupData: {} as SALookupDTO,
  };

  lookup(lookupDTO: LookupDTO): Observable<LookupApiResponse> {
    switch (lookupDTO.idType) {
      case "I":
        return this.lookupViaId(lookupDTO);
      case "P":
        return this.lookupViaPassport(lookupDTO);
      case "A":
        return this.lookupViaAsylum(lookupDTO);
      default:
        return of(this.errorResponse).pipe(delay(1000));
    }
  }

  lookupViaAsylum(lookupDTO: LookupDTO): Observable<LookupApiResponse> {
    return this.http.post<LookupApiResponse>(
      `${environment.apiUri}/profile/lookup`,
      {
        asylumNumber: lookupDTO.number,
        idType: lookupDTO.idType,
        idCountry: lookupDTO.idCountry,
      }
    );
  }

  lookupViaPassport(lookupDTO: LookupDTO): Observable<LookupApiResponse> {
    return this.http.post<LookupApiResponse>(
      `${environment.apiUri}/profile/lookup`,
      {
        passportNumber: lookupDTO.number,
        idType: lookupDTO.idType,
        idCountry: lookupDTO.idCountry,
      }
    );
  }

  lookupViaId(lookupDTO: LookupDTO): Observable<LookupApiResponse> {
    if (!saIdParser.parse(lookupDTO.number!).isValid) {
      return of({ ...this.errorResponse, error: "Invalid ID number" });
    } else {
      return this.http.post<LookupApiResponse>(
        `${environment.apiUri}/profile/lookup`,
        {
          idNumber: lookupDTO.number,
          idType: lookupDTO.idType,
          idCountry: lookupDTO.idCountry,
        }
      );
    }
  }
}
